module.exports = __webpack_public_path__ + "static/media/uriel-soberanes.fe3a7838.jpg";